'use client'
import { useEffect, useState } from 'react'

export function useSubdomain() {
  const [subdomain, setSubdomain] = useState('default')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const host = window.location.hostname
      const extractedSubdomain = host.split('.')[0]
      setSubdomain(extractedSubdomain)
    }
  }, [])

  return subdomain
}
